
        var result = require("!!../../../../node_modules/css-loader/index.js!./stock-import.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/stock-import/stock-import.component.css
// module id = 631
// module chunks = 0